
import { Component, Vue } from 'vue-property-decorator'
import { CONFIGAPI } from '@/api/config'
import { ConfigModule } from '@/store/modules/config'
import { UserModule } from '@/store/modules/user'
import { getRole, getuserCurrentApp } from '@/utils/cookies'
import UpdateDialog from './updateDialog.vue'
import ConfigLogDialog from '../configLog.vue'

@Component({
  name: 'tutorConfig',
  components: {
    UpdateDialog,
    ConfigLogDialog
  }
})
export default class extends Vue {
  private tableData = []
  private columns = [
    { field: 'id', title: 'ID', width: 80 },
    { field: 'name', title: '群组名称', width: 200 },
    // { field: 'team', title: '团队', width: 80, curr: this.userCurrentApp },
    { field: 'role', title: '群组角色', width: 150 },
    { field: 'buildings', title: '基地' },
    { field: 'users', title: '用户' }
  ]

  private updateType = 'add' // 新建/编辑类型 add-新建，edit-编辑
  private currentNode = {} // 当前选择的节点
  private allBuilding = [] // 所有的基地（关联基地需要）
  private allTeams = [] // 所有团队信息
  private total = 0 // 总条数
  private currentPage = 1
  private pageSize = 10

  get userRole() {
    return UserModule.roles || getRole() || ''
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  mounted() {
    this.getTableData()
    this.getAllBuilding()
    this.getAllTeams()
    this.updateColumns()
  }

  updateColumns() {
    if (this.userCurrentApp === '1') {
      // 检查 'team' 字段是否已经存在，以避免重复添加
      if (!this.columns.some(column => column.field === 'team')) {
        // 动态添加 'team' 列
        this.columns.splice(2, 0, { field: 'team', title: '团队', width: 80 })
      }
    } else {
      // 移除 'team' 列，如果存在的话
      this.columns = this.columns.filter(column => column.field !== 'team')
    }
  }

  // 获取笔记本型号数据
  private async getTableData() {
    await CONFIGAPI.getGroupData({
      page: this.currentPage,
      page_size: this.pageSize,
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.total = res.data.count
        this.tableData = res.data.lists
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 获取全部基地树状结构
  getAllBuilding() {
    CONFIGAPI.getBuildingTree({
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.allBuilding = res.data
        // 禁用掉没有基地的地区
        this.allBuilding.map((item: any) => {
          if (!item.children || item.children.length === 0) {
            item.disabled = true
          }
        })
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  getAllTeams() {
    CONFIGAPI.getTeamInfoList({
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.allTeams = res.data.lists.map((item: any) => ({
          id: item.id,
          name: item.name,
          status: item.status,
          app_id: item.app_id
        }))
      }
    }).catch((error) => {
      console.log('发生错误！', error)
    })
  }

  // 查看操作日志
  handleShowLog() {
    ConfigModule.ToggleDialogStatus({
      name: 'configLogDialog',
      value: true
    })
  }

  // 新增
  private handleCreate() {
    this.updateType = 'add'
    ConfigModule.ToggleDialogStatus({
      name: 'groupAddDialog',
      value: true
    })
  }

  // 编辑
  private handleEdit(data: any) {
    this.updateType = 'edit'
    this.currentNode = data
    ConfigModule.ToggleDialogStatus({
      name: 'groupAddDialog',
      value: true
    })
  }

  // 删除
  private handleDelete(data: any) {
    this.$confirm(`确定要删除当前群组么？【${data.name}】`)
      .then(_ => {
        CONFIGAPI.delGroup({
          id: data.id
        }, {
          app_id: this.userCurrentApp
        }).then((res) => {
          if (res.stat === 1) {
            this.$message.success(res.data)
            this.getTableData()
          }
        }).catch((error) => {
          console.log('发生错误！', error)
        })
      })
      .catch(_ => {
      })
  }

  // 子组件接口调用成功后
  private handleSuccess() {
    this.getTableData()
  }

  private handleSizeChange(val: number) {
    this.currentPage = 1
    this.pageSize = val
    this.getTableData()
  }

  private handleCurrentChange(val: number) {
    this.currentPage = val
    this.getTableData()
  }
}
